var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaestro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 19.8605C50 26.6931 44.4721 32.221 37.6395 32.221C34.7554 32.221 32.1116 31.2253 30.0172 29.5773C32.9013 27.3112 34.7211 23.809 34.7211 19.8605C34.7211 15.912 32.867 12.4099 30.0172 10.1438C32.1116 8.49571 34.7554 7.5 37.6395 7.5C44.4721 7.5 50 13.0622 50 19.8605Z",
    fill: "#0099DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0172 10.1438C30.0172 10.1438 30.0172 10.1438 30.0172 10.1438C32.867 12.4099 34.7211 15.912 34.7211 19.8605C34.7211 23.809 32.9013 27.3112 30.0172 29.5773L29.9827 29.5773C27.133 27.3455 25.279 23.809 25.279 19.8606C25.279 15.9121 27.133 12.4099 29.9828 10.1439C29.9828 10.1438 29.9828 10.1439 29.9828 10.1439L30.0172 10.1438Z",
    fill: "#6C6BBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.279 19.8606C25.279 15.9121 27.133 12.4099 29.9828 10.1439C27.8884 8.49578 25.2446 7.50005 22.3605 7.50005C15.5279 7.50005 10 13.028 10 19.8606C10 26.6932 15.5279 32.2211 22.3605 32.2211C25.2446 32.2211 27.8883 31.2253 29.9827 29.5773C27.133 27.3455 25.279 23.809 25.279 19.8606Z",
    fill: "#EB001B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestro);
export default __webpack_public_path__ + "static/media/Maestro.b10b559c1229a027114b82a81bdeec3c.svg";
export { ForwardRef as ReactComponent };